module.exports = __webpack_public_path__ + "media/applicants/device_signup_7-au-36bf8327.jpg";